(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["@adsk/napi-user-onboarding-form"] = factory(require("react"), require("styled-components"), require("react-dom"));
	else
		root["@adsk/napi-user-onboarding-form"] = factory(root["react"], root["styled-components"], root["react-dom"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__8694__, __WEBPACK_EXTERNAL_MODULE__9514__) {
return 